import { cssSpacing, headlineLarge, screenMdMax, headlineMedium, bodyMediumBold, titleLarge, titleMedium, Text, } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { TWO_COLUMN_MAX_WIDTH } from '../../../ui';
import { numbersLgScreen } from './gridColumns';
export const NumbersWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  grid-column: ${numbersLgScreen};
  grid-row: 1;
  padding-bottom: ${cssSpacing('looser-4')};
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: -1 / 1;
    justify-content: unset;
    padding-bottom: ${cssSpacing('base')};
  }
`;
const Number = styled(Text) `
  ${headlineLarge}
  @media (max-width: ${screenMdMax}) {
    ${headlineMedium}
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    ${bodyMediumBold}
  }
`;
const TotalNumber = styled(Text) `
  opacity: 0.3;
  ${titleLarge}
  @media (max-width: ${screenMdMax}) {
    ${titleMedium}
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-inline-start: ${cssSpacing('tighter-4')};
    ${bodyMediumBold}
  }
`;
export const Numbers = ({ number, totalNumber, }) => {
    return (React.createElement(NumbersWrapper, null,
        React.createElement(Number, null, number < 10 ? `0${number}` : `${number}`),
        React.createElement(TotalNumber, null,
            "/ ",
            totalNumber < 10 ? `0${totalNumber}` : `${totalNumber}`)));
};
